<div class="metadata-container">
  <div class="metadata-header">
    <label class="metadata-title">{{ "imagePropertyEdit.properties" | translate }}</label>
  </div>

  <div class="metadata-content">
    <table>
      <tr class="image-metadata" *ngFor="let property of properties">
        <td class="label">{{ property.key | translate }}</td>
        <td class="value">{{ property.value }}</td>
      </tr>
    </table>
  </div>

  <div class="metadata-header">
    <label class="metadata-title">{{ "imagePropertyEdit.metadataTitle" | translate }}</label>
  </div>

  <div class="metadata-content">
    <table *ngIf="metadataRows.length > 0">
      <tr class="image-metadata" *ngFor="let row of metadataRows">
        <td class="label">{{ row.key }}</td>
        <td class="value">{{ row.value }}</td>
      </tr>
    </table>

    <table *ngIf="metadataRows.length === 0">
      <tr>
        <td class="image-metadata no-metadata-label">{{ "imagePropertyEdit.noMetadata" | translate }}</td>
      </tr>
    </table>
  </div>
</div>
